import { useEffect, useState } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';

import { Backdrop, CircularProgress } from '@mui/material';
import { PageName, ReservationInfo } from './Index';
import { notMatchCustomErrorMessage } from '@/lib/sentryClient';
import * as Sentry from '@sentry/react';
import { executeGetAtAllResponse } from '@/client/rest';

enum ValidationStatus {
  Sent = 'SENT',
  Invaild = 'INVAILD',
  Success = 'SUCCESS'
}

export function ValidationPage(props: any) {
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;

    const timerId = setInterval(() => {
      vertificateId(props.reservationInfo).then((res) => {
        switch (res) {
          case ValidationStatus.Success:
            props.setActivePage(PageName.Rating);
            break;
          case ValidationStatus.Sent:
            props.setActivePage(PageName.AfterLow);
            break;

          default:
            props.setActivePage(PageName.Invalid);
            break;
        }
      });

      setPaused(true);
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, [paused]);

  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

async function vertificateId(reservationInfo: ReservationInfo): Promise<ValidationStatus> {
  try {
    const cognitoId = await fetchCognitoId();
    if (cognitoId === undefined) return ValidationStatus.Invaild;
    const query = { cognitoId: cognitoId, ...reservationInfo };
    const res = await executeGetAtAllResponse({
      apiName: 'medirecoWebApi',
      path: '/validate-reservation',
      options: {
        queryParams: query
      }
    });
    if (res.statusCode === 404) {
      return ValidationStatus.Sent;
    }
    return ValidationStatus.Success;
  } catch (e: any) {
    if (e instanceof Error && notMatchCustomErrorMessage(e.name)) {
      Sentry.captureException(e);
    }

    if (e.response.statusCode === 404) {
      return ValidationStatus.Sent;
    }
  }
  return ValidationStatus.Invaild;
}
export async function fetchCognitoId(): Promise<string | undefined> {
  let attributes = await fetchUserAttributes();
  return attributes.sub;
}
